import { withTranslation } from "next-i18next";
import { useState, memo, useCallback, useEffect } from "react";
import ahoy from "@lib/ahoy";
import { analytics } from "@lib/trackers/analytics";
import { useCurrentUser } from "@hooks/use-current-user";
import { useFilterRecentlyModified } from "@hooks/use-catalog";
import Button from "@components/core/Button";
import Input from "@components/core/Input";

const mainIndex = process.env.NEXT_PUBLIC_ALGOLIA_MAIN_INDEX_V2;

const AvailabilitiesSection = memo(function AvailabilitiesSection({
  setUiState,
  sizeItems,
  isFilterAvailableChecked,
  t,
}) {
  const user = useCurrentUser();
  const filterRecentlyModified = useFilterRecentlyModified();

  const [availabilitiesInfoOpen, setAvailabilitiesInfoOpen] = useState(false);
  const [switchIsChecked, setSwitchIsChecked] = useState(isFilterAvailableChecked);

  const switchInStock = useCallback(() => {
    const eventData = {
      button: "filter",
      filter: "availabilities",
      value: isFilterAvailableChecked ? "all" : "in_stock",
    };
    ahoy("$click", eventData);
    analytics.track("$click", eventData);

    filterRecentlyModified("availabilities");

    const newIsChecked = !isFilterAvailableChecked;

    setSwitchIsChecked(newIsChecked);

    const selectedSizes = sizeItems.filter((item) => item.isRefined).map((item) => item.value);

    setTimeout(() => {
      if (newIsChecked) {
        if (user?.c1_dedicated) {
          setUiState((prev) => ({
            ...prev,
            [mainIndex]: {
              ...prev[mainIndex],
              refinementList: {
                ...prev[mainIndex].refinementList,
                in_stock: [],
                in_stock_for_c1: ["true"],
                sizes: [],
                available_sizes: [],
                available_sizes_for_c1: selectedSizes,
              },
            },
          }));
        } else {
          setUiState((prev) => ({
            ...prev,
            [mainIndex]: {
              ...prev[mainIndex],
              refinementList: {
                ...prev[mainIndex].refinementList,
                in_stock: ["true"],
                in_stock_for_c1: [],
                sizes: [],
                available_sizes: selectedSizes,
                available_sizes_for_c1: [],
              },
            },
          }));
        }
      } else {
        setUiState((prev) => ({
          ...prev,
          [mainIndex]: {
            ...prev[mainIndex],
            refinementList: {
              ...prev[mainIndex].refinementList,
              in_stock: user?.c1_dedicated ? [] : ["false", "true"],
              in_stock_for_c1: user?.c1_dedicated ? ["false", "true"] : [],
              sizes: selectedSizes,
              available_sizes: [],
              available_sizes_for_c1: [],
            },
          },
        }));
      }
    }, 200);
  }, [filterRecentlyModified, isFilterAvailableChecked, setUiState, sizeItems, user?.c1_dedicated]);

  useEffect(() => {
    setSwitchIsChecked(isFilterAvailableChecked);
  }, [isFilterAvailableChecked]);

  return (
    <div
      className="p-3 border-bottom d-flex justify-content-between"
      key="availabilities"
    >
      <div>
        <div className="d-flex align-items-center">
          <span>{t("catalog:filters.section_titles.availabilities")}</span>
          <Button
            variant="link-primary"
            leftIconName="circle-info"
            onClick={() => setAvailabilitiesInfoOpen(true)}
            size="sm"
          />
        </div>
        {availabilitiesInfoOpen && (
          <div className="font-size-xs text-gray mt-2">
            {t("catalog:filters.availabilities.info")}
          </div>
        )}
      </div>
      <Input
        type="switch"
        checked={switchIsChecked}
        onChange={switchInStock}
      />
    </div>
  );
});

export default withTranslation("catalog")(AvailabilitiesSection);
